document.addEventListener("DOMContentLoaded", function () {
  function vvHandleScroll(button, slider, direction) {
    button.addEventListener("click", function () {
      const vvScrollAmount = direction * 5000;
      slider.scrollLeft += vvScrollAmount;
      slider.style.scrollBehavior = "smooth";
    });
  }

  function vvUpdateButtonVisibility() {
    const vvRecommendedProductsSlider = document.getElementById("vv-recommended-products-slider");
    const vvRelatedProductsSlider = document.getElementById("vv-related-products-slider");

    const vvRecommandationButtonLeft = document.getElementById("vv-recommendation-scrolling-left");
    const vvRecommandationButtonRight = document.getElementById("vv-recommendation-scrolling-right");
    const vvRelatedButtonLeft = document.getElementById("vv-related-scrolling-left");
    const vvRelatedButtonRight = document.getElementById("vv-related-scrolling-right");

    if (vvRecommendedProductsSlider) {
      vvRecommandationButtonLeft.style.visibility = vvRecommendedProductsSlider.scrollLeft > 0 ? "visible" : "hidden";
      vvRecommandationButtonRight.style.visibility = vvRecommendedProductsSlider.scrollLeft + vvRecommendedProductsSlider.clientWidth < vvRecommendedProductsSlider.scrollWidth ? "visible" : "hidden";
    }

    if (vvRelatedProductsSlider) {
      vvRelatedButtonLeft.style.visibility = vvRelatedProductsSlider.scrollLeft > 0 ? "visible" : "hidden";
      vvRelatedButtonRight.style.visibility = vvRelatedProductsSlider.scrollLeft + vvRelatedProductsSlider.clientWidth < vvRelatedProductsSlider.scrollWidth ? "visible" : "hidden";
    }
  }

  const vvRecommandationButtonRight = document.getElementById("vv-recommendation-scrolling-right");
  const vvRecommandationButtonLeft = document.getElementById("vv-recommendation-scrolling-left");
  const vvRelatedButtonRight = document.getElementById("vv-related-scrolling-right");
  const vvRelatedButtonLeft = document.getElementById("vv-related-scrolling-left");

  const vvRecommendedProductsSlider = document.getElementById("vv-recommended-products-slider");
  const vvRelatedProductsSlider = document.getElementById("vv-related-products-slider");

  if (vvRecommandationButtonRight) {
    vvHandleScroll(vvRecommandationButtonRight, vvRecommendedProductsSlider, 1);
  }
  if (vvRecommandationButtonLeft) {
    vvHandleScroll(vvRecommandationButtonLeft, vvRecommendedProductsSlider, -1);
  }
  if (vvRelatedButtonRight) {
    vvHandleScroll(vvRelatedButtonRight, vvRelatedProductsSlider, 1);
  }
  if (vvRelatedButtonLeft) {
    vvHandleScroll(vvRelatedButtonLeft, vvRelatedProductsSlider, -1);
  }

  vvUpdateButtonVisibility();
  if (vvRecommendedProductsSlider) {
    vvRecommendedProductsSlider.addEventListener("scroll", vvUpdateButtonVisibility);
  }
  if (vvRelatedProductsSlider) {
    vvRelatedProductsSlider.addEventListener("scroll", vvUpdateButtonVisibility);
  }
});
